<template>
  <rabbey-base-drawer
    title="Consultas de cuentas contable"
    :drawer.sync="drawer"
    size="65%"
    @open="onOpen"
    @close="onClose"
  >
    <div class="flex reverse align-flex-end mt-0 mb-10">
      <div class="box mr-5">
        <el-input
          v-model="search"
          size="mini"
          placeholder="Buscar cuenta"
          clearable
          @keyup.native.prevent="__filterSearchAccType"
          @clear="onClear"
        />
      </div>

      <div class="box mr-5">
        <el-select
          v-model="month"
          placeholder="Mes de consulta "
          class="box-item"
          size="mini"
          clearable
          @change="handlerChanges"
        >
          <el-option
            v-for="item in monthList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="box mr-15">
        <label style="font-weight: bold; font-size: 20px"
          >Mes de consulta</label
        >
      </div>
    </div>
    <el-row>
      <el-tabs v-model="sectionActive" :before-leave="displayRefreshTable">
        <el-tab-pane label="INGRESOS" name="income">
          <AccountTabTable
            active-tab="income"
            ref="income"
            :columns="columns"
            :year="year"
            :month="month"
            :search="search"
          />
        </el-tab-pane>

        <el-tab-pane label="COSTOS" name="costs">
          <AccountTabTable
            active-tab="costs"
            ref="costs"
            :columns="columns"
            :year="year"
            :month="month"
            :search="search"
          />
        </el-tab-pane>

        <el-tab-pane label="GASTOS" name="expenses">
          <AccountTabTable
            active-tab="expenses"
            ref="expenses"
            :columns="columns"
            :year="year"
            :month="month"
            :search="search"
          />
        </el-tab-pane>

        <el-tab-pane label="ACTIVOS" name="active">
          <AccountTabTable
            active-tab="active"
            ref="active"
            :columns="columns"
            :year="year"
            :month="month"
            :search="search"
          />
        </el-tab-pane>

        <el-tab-pane label="PASIVOS" name="passives">
          <AccountTabTable
            active-tab="passives"
            ref="passives"
            :columns="columns"
            :year="year"
            :month="month"
            :search="search"
          />
        </el-tab-pane>

        <el-tab-pane label="CAPITAL" name="capital">
          <AccountTabTable
            active-tab="capital"
            ref="capital"
            :columns="columns"
            :year="year"
            :month="month"
            :search="search"
          />
        </el-tab-pane>

        <el-tab-pane label="ENTRADA MANUAL" name="ManualEntry">
          <ManualEntry
            :RenglonID="row.Id"
            v-on:close="onCloseManualEntry"
          ></ManualEntry>
        </el-tab-pane>
      </el-tabs>
    </el-row>

    <!-- DIALOG DE AGREGAR FECHA DE CUENTA -->
    <el-dialog
      title="Fecha del Movimiento"
      :visible.sync="showDialog"
      width="30%"
      append-to-body
      center
      v-loading="formLoading"
    >
      <el-form
        ref="AddingAccForm"
        :model="form"
        label-position="top"
        status-icon
        :rules="formRules"
      >
        <el-form-item label="Número del Documento">
          <el-input disabled v-model="form.AccountNumber"> </el-input>
        </el-form-item>
        <el-form-item label="Nombre de la Cuenta">
          <el-input disabled v-model="form.AccountName"> </el-input>
        </el-form-item>
        <el-form-item label="Detalles">
          <el-input disabled v-model="form.Comentary"> </el-input>
        </el-form-item>
        <el-form-item label="Movimiento del mes">
          <el-input-number disabled v-model="form.Amount"> </el-input-number>
        </el-form-item>
        <el-form-item label="Fecha del Movimiento" prop="PostingDate">
          <el-date-picker
            v-model="form.PostingDate"
            type="date"
            placeholder="Fecha del Movimiento"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="onSubmit">Confirm</el-button>
      </span>
    </el-dialog>
  </rabbey-base-drawer>
</template>

<script>
import { debounce } from "lodash";

import InputColumn from "@/components/functionals/InputColumn.vue";
import DatePickerInLine from "@/components/functionals/DatePickerInLine.vue";
import ManualEntry from "../ManualEntry.vue";
import AccountTabTable from "./AccountTabTable.vue";

export default {
  name: "AddAccount",

  events: ["refresh"],

  components: { ManualEntry, AccountTabTable },

  props: {
    year: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      sectionActive: "",
      drawer: false,
      showDialog: false,
      formLoading: false,
      row: { Id: 0 },
      headFormat: {
        background: "darkgray",
        color: "black"
      },
      form: {
        AccountNumber: "",
        AccountName: "",
        Comentary: "",
        Amount: 0,
        PostingDate: null
      },
      formRules: {
        PostingDate: [
          {
            required: true,
            message: "Por favor seleccione una Fecha de Movimiento",
            trigger: "blur"
          }
        ]
      },
      columns: [
        // {
        //   prop: "AccoundRowID",
        //   label: "NO.",
        //   width: 150,
        //   sortable: true
        // },
        {
          prop: "AccountNumber",
          label: "Numero de Documento",
          minWidth: 90,
          sortable: true
        },
        {
          prop: "AccountName",
          label: "Nombre de cuenta",
          minWidth: 100,
          sortable: true,
          formatter: InputColumn,
          attrs: {
            inputValue: "AccountName",
            disabled: () => false
          }
        },
        {
          prop: "Comentary",
          label: "Detalles",
          minWidth: 100,
          sortable: true,
          formatter: InputColumn,
          attrs: {
            inputValue: "Comentary",
            disabled: () => false
          }
        },
        {
          prop: "Amount",
          label: "Movimiento del mes",
          minWidth: 100,
          sortable: true,
          formatter: InputColumn,
          attrs: {
            inputValue: "Amount",
            disabled: () => false
          }
        },
        {
          prop: "PostingDate",
          label: "Fecha",
          minWidth: 100,
          sortable: true,
          formatter: DatePickerInLine,
          attrs: {
            openDialog: this.OpenDateDialog
          }
        }
      ],
      search: "",
      month: 1,
      monthList: [
        { value: 1, label: "Enero" },
        { value: 2, label: "Febrero" },
        { value: 3, label: "Marzo" },
        { value: 4, label: "Abirl" },
        { value: 5, label: "Mayo" },
        { value: 6, label: "Junio" },
        { value: 7, label: "Julio" },
        { value: 8, label: "Agosto" },
        { value: 9, label: "Septiembre" },
        { value: 10, label: "Octubre" },
        { value: 11, label: "Noviembre" },
        { value: 12, label: "Diciembre" }
      ]
    };
  },

  methods: {
    show(row) {
      this.row = row;
      this.drawer = true;
    },

    OpenDateDialog(data) {
      this.form = data;
      this.showDialog = true;
    },

    onSubmit() {
      this.$refs.AddingAccForm.validate((valid) => {
        if (valid) {
          this.formLoading = true;
          this.$http
            .post("/api/CashFlow/AddRowCashFlowDetail", {
              AccountNumber: this.form.AccountNumber,
              AccountName: this.form.AccountName,
              commentary: this.form.Comentary,
              Amount: this.form.Amount,
              PostingDate: this.form.PostingDate,
              RowCashFlowId: this.row.Id,
              RowType: this.row.Type
            })
            .then(() => {
              this.$emit("refresh", this.row.Id);
              this.$notify.success({
                duration: 5000,
                message: "Cuaeta contable agregada al renglón",
                title: "Información",
                position: "top-left"
              });
              this.showDialog = false;
            })
            .catch((error) => {
              this.$message.error("Error al consultar los Registros");
              console.error(error);
            })
            .finally(() => {
              this.formLoading = false;
            });
        } else {
          this.$message.error(
            "Favor llene correctamente los campos requeridos"
          );
        }
      });
    },

    onOpen() {
      this.sectionActive = "income";
    },

    onClose() {
      this.sectionActive = "";
      this.form = {
        AccountNumber: "",
        AccountName: "",
        Amount: 0,
        PostingDate: null
      };
      this.row = { Id: 0 };
    },

    onCloseManualEntry() {
      this.$emit("refresh", this.row.Id);
      this.drawer = false;
    },

    displayRefreshTable(activeName) {
      if (activeName !== "ManualEntry" && this.$refs[activeName])
        this.$refs[activeName].refreshData();
      return true;
    },

    handlerChanges() {
      if (this.sectionActive !== "ManualEntry")
        this.$refs[this.sectionActive].refreshData();
    },

    __filterSearchAccType: debounce(function () {
      this.filterAccount();
    }, 300),

    filterAccount() {
      if (
        this.sectionActive !== "ManualEntry" &&
        this.$refs[this.sectionActive]
      )
        this.$refs[this.sectionActive].refreshData();
    },

    onClear() {
      this.search = "";
      // dale tiempo a que se propare el search;
      setTimeout(() => {
        this.filterAccount();
      }, 100);
    }
  }
};
</script>
